<template>
  <div
    :class="{
      'top-wrapper-default-dashboard': defaultDashboard,
      'top-wrapper': !defaultDashboard,
    }"
  >
    <CustomDashboardComp
      @widget="confirmAdd"
      @changeDashboard="onDashboardSelect"
      @onMountEvenet="onMountEvent"
    />

    <div v-if="loading" class="home-loading-container">
      <RexSkeletonV3
        :loading="loading"
        :paragraph="homepageLoaderConfigPara"
        class="home-skleton"
      >
      </RexSkeletonV3>
      <RexSkeletonV3
        :loading="loading"
        :paragraph="homepageLoaderConfigPara"
        class="home-skleton"
      >
      </RexSkeletonV3>
    </div>

    <div class="addWidget" v-else-if="NotAdded">
      <AddWidget />
    </div>
    <div class="d-flex-1-column" v-else-if="defaultDashboard">
      <HomeRevamped v-if="isBetaDashboard" />
      <HomeGraphs v-else />
    </div>
    <div v-else>
      <div>
        <StatusLabels :labels="labels" />
      </div>
      <draggable
        v-model="cTemplate"
        class="wrapper"
        @change="onOrderChange"
        handle=".cus-home-drag-n-drop-pointer "
      >
        <div
          class="chart-element"
          v-for="(chartConfig, index) in cTemplate"
          :key="chartConfig?.widgetName + index"
        >
          <PermissionDeniedWidget
            v-if="!chartConfig.accessible"
            :chartConfig="chartConfig"
            :draggable="true"
          />
          <SummaryBuilder
            v-else-if="chartConfig?.chartType === summaryMetricType"
            :smryConfig="chartConfig"
          />
          <MultiLineGraphBuilder
            v-else-if="chartConfig?.chartType === MultilineGraph"
            :graphConfig="chartConfig"
          />
          <GraphBuilder
            v-else
            :chartConfig="getChartConfigForGraphBuilder(chartConfig)"
            :index="index"
            :layoutIndex="0"
          />
        </div>
      </draggable>
      <div>
        <TableWidget :tables="tables" />
      </div>
    </div>
    <RexModalV3
      :show="showDelModal"
      @onClose="cancelDelete"
      @onSubmit="confirmDelete"
      :title="$t('deleteWidget')"
      :submitText="$t('delete')"
    >
      <template #body>
        <div class="d-flex del-body pb-4">
          {{ $t('deleteWidgetText') }}
        </div>
      </template>
    </RexModalV3>
  </div>
</template>
<script>
import GraphBuilder from '@/components/Home/CustomDashboard/CustomGraphBuilder.vue';
import StatusLabels from '@/components/Home/CustomDashboard/StatusLabels.vue';
import TableWidget from '@/components/Home/CustomDashboard/TableWidget.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import RexInfoLabel from '@/rex-components/rex-info-label.vue';
import TheFooter from '../Main/TheFooter.vue';
import { CustomService } from '@/services/api/custom.service';
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import HomeGraphs from './HomeGraphs.vue';
import CustomDashboardComp from './CustomDashboardComp.vue';
import AddWidget from './CustomDashboard/AddWidget.vue';
import { notificationSucess, notificationError } from '@/utils/notification';
import HomeRevamped from './revamp/HomeRevamped.vue';
import SummaryBuilder from '@/components/Home/CustomDashboard/SummaryBuilder.vue';
import { VueDraggableNext } from 'vue-draggable-next';
import {
  customGraphAndSummaryTypes,
  STATUS_LABEL,
  TABLE_WIDGET,
  SummaryMetric,
  MultilineGraph,
} from '@/components/Home/utils/custom.home.types';
import MultiLineGraphBuilder from '@/components/Home/CustomDashboard/MultiLineGraphBuilder.vue';
import { usePermissions } from '@/hooks/usePermissions';
import PermissionDeniedWidget from '@/components/Home/PermissionDeniedWidget.vue';
import RexSkeletonV3 from '@/rex-components/RexSkeletonV3.vue';
import { homepageLoaderConfigPara } from './utils/constants';
import { HOME_RESOURCE_GROUP } from '@/router/constant';

export default {
  name: 'HomeDetail',
  components: {
    AddWidget,
    GraphBuilder,
    RexInfoLabel,
    TheFooter,
    HomeGraphs,
    CustomDashboardComp,
    RexModalV3,
    StatusLabels,
    TableWidget,
    HomeRevamped,
    SummaryBuilder,
    draggable: VueDraggableNext,
    MultiLineGraphBuilder,
    PermissionDeniedWidget,
    RexSkeletonV3,
  },
  data() {
    return {
      routeText: true,
      cTemplate: [],
      showDelModal: false,
      defaultDashboard: false,
      dashboardID: '',
      betaFlag: false,
      labels: [],
      tables: [],
      MultilineGraph,
      loading: true,
      homepageLoaderConfigPara,
    };
  },
  computed: {
    ...mapState('homeState', ['deleteWidgetId', 'selectedWidgetId']),
    ...mapState('globalState/user', ['dashboard']),
    ...mapGetters('globalState/user', {
      dashboardGetter: 'getDashboard',
    }),
    NotAdded() {
      if (
        this.cTemplate.length > 0 ||
        this.labels.length > 0 ||
        this.tables.length > 0 ||
        (this.hasConfigPermission && this.defaultDashboard === true)
      ) {
        return false;
      } else {
        return true;
      }
    },
    isBetaDashboard() {
      return this.selectedWidgetId === 'defaultBeta';
    },
    hasHomeWritePermission() {
      const { hasCapabilityWritePermission } = usePermissions();
      return hasCapabilityWritePermission(HOME_RESOURCE_GROUP);
    },
    hasConfigPermission() {
      const { hasCapabilityPermission } = usePermissions();
      return hasCapabilityPermission('CONFIG');
    },
  },
  methods: {
    ...mapMutations('homeState', ['setdeleteWidgetId', 'setSelectedWidgetId']),
    ...mapMutations('apmState/dashboard', ['setDashboardTab']),
    sortWidgetsBasedOnId(list) {
      if (!list || !Array.isArray(list)) return [];
      return list.sort((w1, w2) => w1.id - w2.id);
    },
    getChartConfigForGraphBuilder(chartConfig) {
      return {
        ...chartConfig,
        aggregation: chartConfig.aggregationInfo?.aggregation || '',
        aggregationNum: chartConfig.aggregationInfo?.aggregationNum || '',
      };
    },
    sortWidgetBasedonOrdering(list, orderList) {
      const updatedList = [];
      list.forEach((obj) => {
        updatedList[orderList.indexOf(obj.id?.toString())] = obj;
      });
      return updatedList.filter((list) => list);
    },
    async getTemplate() {
      if (this.dashboardID) {
        try {
          const { data } = await CustomService.getDashboardTemplate(
            this.dashboardID,
          );
          if (data.success) {
            const widgets = data.data[0].widgets;
            const orderList = data.data[0].widgetOrder.split(',');

            let graphsAndSummary = [];
            for (let graph of customGraphAndSummaryTypes) {
              graphsAndSummary = widgets[graph]
                ? [...graphsAndSummary, ...widgets[graph]]
                : graphsAndSummary;
            }
            graphsAndSummary = graphsAndSummary.map((obj) => {
              if (obj.chartType !== SummaryMetric) {
                obj.metricName = obj.metricName[0]?.metricName;
              }
              return obj;
            });
            this.cTemplate = this.sortWidgetBasedonOrdering(
              graphsAndSummary,
              orderList,
            );
            this.labels = this.sortWidgetsBasedOnId(widgets[STATUS_LABEL]);
            this.tables = this.sortWidgetsBasedOnId(widgets[TABLE_WIDGET]);
          } else {
            this.cTemplate = [];
            this.labels = [];
            this.tables = [];
            this.defaultDashboard = true;
          }
        } catch (error) {
          console.log('resp.error', error);
          this.cTemplate = [];
          this.labels = [];
          this.tables = [];
          this.defaultDashboard = true;
        }
      }
    },
    cancelDelete() {
      this.showDelModal = false;
      this.setdeleteWidgetId('');
    },
    onDashboardSelect(item) {
      this.betaFlag = !!item.isBeta;
    },
    onMountEvent(item) {
      if (!item && !this.hasConfigPermission) {
        this.defaultDashboard = false;
      }
      this.setSelectedWidgetId(item);

      this.loading = false;
    },
    confirmDelete() {
      this.showDelModal = false;
      CustomService.deleteDashboardWidget({
        dashId: this.dashboardID,
        widgetId: this.deleteWidgetId,
      })
        .then((resp) => {
          notificationSucess(this.$t('deleteWidgetSuccMsg'));
          this.getTemplate();
        })
        .catch((err) => {
          console.log('error', err);
          notificationError(this.$t('deleteWidgetErrMsg'));
        });
      this.setdeleteWidgetId('');
    },
    openWidget(val) {
      //console.log('openWidget', val);
    },
    cancelAdd() {},
    confirmAdd(item) {
      CustomService.postDashboardTemplate({
        id: this.dashboardID,
        widget: item,
      })
        .then(() => {
          this.getTemplate();
          notificationSucess(this.$t('widgetAddedSuccess'));
        })
        .catch((error) => {
          console.log('error', error);
          notificationError(
            (error.status === 400 && error?.data?.message) ||
              this.$t('errorAddingWidget'),
          );
        });
      // this.$forceUpdate()
    },
    changeDashboardTemplate(item) {
      if (
        item?.id === 'default' ||
        item?.id === 'defaultBeta' ||
        item?.id === ''
      ) {
        this.defaultDashboard = true;
      } else {
        this.defaultDashboard = false;
        this.dashboardID = item?.id;
        this.cTemplate = [];
        this.labels = [];
        this.tables = [];
        this.getTemplate();
      }
    },
    setDashboardID() {
      if (
        this.dashboardGetter === '' ||
        this.dashboardGetter === 'default' ||
        this.dashboardGetter === 'defaultBeta'
      ) {
        this.defaultDashboard = true;
        this.setSelectedWidgetId(this.dashboardGetter);
      } else {
        this.dashboardID = this.dashboardGetter;
      }
    },
    async onOrderChange() {
      try {
        const resp = await CustomService.reorderDashboardWidget({
          dashId: this.dashboardID,
          widgetOrder: this.cTemplate.map((obj) => obj.id).join(','),
        });
        if (!resp.success) {
          notificationError(this.$t('errWhileUpdatingPosition'));
        }
      } catch (error) {
        console.log('error', error);
        notificationError(this.$t('errWhileUpdatingPosition'));
      }
    },
  },
  mounted() {
    this.summaryMetricType = SummaryMetric;
    this.setDashboardTab('Instance');
    this.setDashboardID();
    this.dashboardID && this.getTemplate();
    // this.cTemplate = template.lineCharts
  },
  watch: {
    deleteWidgetId: function (newValue, oldValue) {
      if (newValue !== '') {
        this.showDelModal = true;
      }
    },
    selectedWidgetId: function (newValue, oldValue) {
      let item = {
        id: newValue,
      };
      this.changeDashboardTemplate(item);
    },
  },
};
</script>
<style lang="scss" scoped>
.full {
  margin-top: 1em;
  display: flex;
  margin-right: 0.5625em;
  .home-left {
    margin-right: 1.5625em;
    width: 50%;
  }
  .home-right {
    width: 50%;
    .card {
      width: 100%;
      margin-bottom: 1.25em;
      border-radius: 0.625em;
      @include dropshadow-effect;
      border-radius: 1.0625em;
    }
  }
}
.addWidget {
  height: 56rem;
}
.wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(37.063rem, 1fr));
  column-gap: 1rem;
  margin-top: 1.438em;
  overflow-y: scroll;
}
.top-wrapper {
  min-height: 90vh;
}

.top-wrapper-default-dashboard {
  min-height: 90vh;
  display: flex;
  flex-direction: column;
}
.chart-element {
  margin-bottom: 1.5em;
  margin-top: 0.125em;
  margin-left: 0.125em;
}

.home-loading-container {
  padding: 2rem;
  display: flex;
  gap: 0.5rem;

  .home-skleton {
    flex: 1;
  }
}
</style>
